module.exports = __webpack_public_path__ + "img/vip-c-icon.a71e83be.png";